import React, { Fragment, useCallback } from 'react';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import { Control } from '../Control';
import { UNLIMITED } from './constants';
import ValidationIcon from '../Icons/ValidationIcon';
import { getInitialIndex, msToPeriods } from './helpers';

import style from './index.scss';

export const tk = arg => `playtech.mobile.system.dp.display.${arg}`;

export const DatePointDisplay = ({ number, text }) => (
    <span className={style.datePointDisplay}>
        <span>{number}</span>
        <span>{` ${text}`}</span>
    </span>
);

export const Separator = ({ separator }) => <span className={style.separator}>{separator}</span>;

export const DateDisplay = withTranslations(({ value, useDays, useHours, useMinutes, t }) => {
    const initialIndex = getInitialIndex({ useDays, useHours });
    const [days, hours, minutes] = msToPeriods(value, (initialIndex - 1) / 2);

    return (
        <Fragment>
            {useDays && <DatePointDisplay number={days} text={t(tk('dd'))} />}
            {useDays && useHours && <Separator separator={' / '} />}
            {useHours && <DatePointDisplay number={hours} text={t(tk('hh'))} />}
            {useHours && useMinutes && <Separator separator={' : '} />}
            {useMinutes && <DatePointDisplay number={minutes} text={t(tk('min'))} />}
        </Fragment>
    );
});

export const DateSpanDisplay = ({
    /* rff render props */
    meta,

    /* user provided props */
    id,
    label,
    hint,
    className,
    classNames,
    value,
    onClick,
    useDays,
    useHours,
    useMinutes,
    t
}) => {
    const isUnlimited = value === UNLIMITED;
    const { active, touched, error } = meta;
    const onKeyDown = useCallback(event => event.stopPropagation(), []);

    return (
        <AccessibilityElement onClick={onClick} onKeyDown={onKeyDown}>
            <Control {...{
                id,
                meta,
                className,
                classNames,
                label,
                hint,
                animate: true
            }}>
                <span className={style.displayContent}>
                    {isUnlimited
                        ? <div className={style.unlimited}>{t(tk(UNLIMITED))}</div>
                        : <DateDisplay {...{ value, useDays, useHours, useMinutes }} />
                    }
                </span>

                {touched && !active && (
                    <ValidationIcon
                        animate={true}
                        isValid={!error}
                        aria-label={error}
                        tabIndex={error ? 0 : -1}
                    />
                )}
            </Control>
        </AccessibilityElement>
    );
};

export default withTranslations(DateSpanDisplay);
